import { resolveDiscoverRowTitle, useTranslation } from "@next-platform/client-common-core";

const useDiscoverRowTitle = (titleKey: string): string => {
  const { t } = useTranslation();
  return resolveDiscoverRowTitle({ titleKey, t });
};

export default useDiscoverRowTitle;
